module.exports = __webpack_public_path__ + "static/media/imagen_2024-11-11_235355051.232237f1.svg";